import { h } from 'preact';

import { getLabel } from '../../../../labels/labelling-service';
import { IconEdit, IconHeart, IconStar, IconArrowLink } from '../../../components/1-foundation/icons/icons';
import SkyItTab from '../../../components/3-molecules/sky-it-tabs/sky-it-tab';
import SkyItTabs from '../../../components/3-molecules/sky-it-tabs/sky-it-tabs';
import { getDataFromBlock } from '../getters/get-data-from-block';
import { buildAllPreferences } from '../helpers/build-all-preferences';

import { renderBlock } from './render-block';
import { renderPremium } from './render-premium';

import { renderPreferencesFollowed, renderYourContents } from '.';

export const renderTabsAndContent = ({
  blocks,
  selectedTab,
  pageHandlers,
  widget,
  isUserLogged,
  pageState,
  pageActions,
  WPNCtx,
  newslettersCtx,
  parselyCtx,
}) => {
  const [allUserPreferences, allContentsByUserPreferences] = buildAllPreferences(parselyCtx);
  const blockNoContent = blocks?.find((element) => element.type === widget.blockTypes.noContent);
  const blocksContent = blocks?.map((block) =>
    renderBlock({
      type: block.type,
      data: getDataFromBlock({ block, widget, isUserLogged }),
      pageState,
      pageActions,
      widget,
      WPNCtx,
      newslettersCtx,
      parselyCtx,
      pageHandlers,
    })
  );

  if (!isUserLogged) {
    return (
      <div className="c-user-preferences__highlighted-wrapper">
        <div className="l-inner-grid">
          <div className="l-inner-grid__main">{blocksContent}</div>
        </div>
      </div>
    );
  }

  if (isUserLogged) {
    const showPreferencesFollowed = Boolean(allUserPreferences.length);

    const tabs = [];
    tabs.push(
      <SkyItTab key={0} title={getLabel('tabs.premium')} icon={<IconStar modifiers={['c-light', 'xsmall', 'star']} />}>
        {renderPremium({ pageState, pageActions, premiumWidgetConfig: widget.premiumWidget })}
      </SkyItTab>
    );
    tabs.push(
      <SkyItTab
        key={1}
        title={getLabel('tabs.your.contents')}
        icon={<IconHeart modifiers={['c-light', 'xsmall', 'heart']} />}
      >
        {renderYourContents({
          pageHandlers,
          allContentsByUserPreferences,
          selectedTab,
          pageActions,
          data: blockNoContent ? getDataFromBlock({ block: blockNoContent, widget, isUserLogged }) : {},
        })}
      </SkyItTab>
    );
    tabs.push(
      <SkyItTab
        key={2}
        title={getLabel('tabs.personalize')}
        icon={<IconEdit modifiers={['c-light', 'xsmall', 'edit']} />}
      >
        {/* NOTE: pass onOptionRemove: pageHandlers.handleOptionRemove to remove the preference */}
        {showPreferencesFollowed && renderPreferencesFollowed(allUserPreferences)}
        {blocksContent}
      </SkyItTab>
    );
    /**
     * NOTE: CONDITIONAL LOGIC ON PREMIUM TO BE REMOVED
     */

    return (
      <div className="c-user-preferences__sky-it-tabs-wrapper">
        <SkyItTabs selectedTab={selectedTab} onTabClick={pageHandlers.handleTabClick}>
          {tabs}
        </SkyItTabs>
      </div>
    );
  }
};
